/* ============================================================
   GEBERT & WESCHKA — 3D-Viewer (Startseite, Breadboard-Abschnitt,
   Produktseite). Nur three.js-Kern (keine Addons, kein Modul-Mapping),
   wird beim ersten Sichtkontakt nachgeladen. Ohne WebGL bleibt das
   statische Ersatzbild stehen (Klasse gw-3d-fail).

   Modelle (prozedural, Einheit 1 = 10 mm):
   - breadboard: schwarz eloxierte Platte, M6-Gewinde im Raster
     (Standard 25 mm, 12,5 mm Randabstand) mit Fase oben und unten,
     Befestigungs-Senkbohrungen ⌀11/⌀6,5 (vier Ecken + Mitte),
     umlaufend gefaste Kanten, Dicke aus data-thickness (12,7 mm).
   - cnc: gefrästes Aluminiumteil (Absatz, Plateau, Bund mit
     Lagersitz, Gewinde-Lochkreis, Senkbohrungen, Langloch, Tasche).
   - table: Aluprofil-Tisch (nur wenn per data-showcase angefordert).

   ÖFFENTLICHE SCHNITTSTELLE (bitte stabil halten)
   -----------------------------------------------
   Markup:
     <div class="gw-3d"
          data-l="450"            Länge in mm (X)          Standard 300
          data-w="300"            Breite in mm (Z)         Standard 300
          data-thickness="12.7"   Dicke in mm              Standard 12,7
          data-pitch="25"         Rasterabstand in mm      Standard 25
          data-autorotate="1"     0 = keine Eigendrehung
          data-showcase="cnc,breadboard">   optional: Produktwechsel;
                                  erster Eintrag = Startbild
       <div class="gw-3d-fallback">…</div>   Ersatzbild ohne WebGL
     </div>
   Laden: <script src="gw-3d.js" defer>; mehrfaches Einbinden ist
   unschädlich. Neue Hosts im DOM: window.GW3D.scan(scope).

   JavaScript (nach der Initialisierung):
     host.__gw3d                          Viewer-Instanz
     window.GW3D.get(host)                dasselbe, null wenn noch nicht bereit
     host.addEventListener('gw3d:ready', e => e.detail.viewer …)
                                          feuert einmal, sobald der Viewer steht
     viewer.setBoard({ l, w, thickness, pitch })
                                          Platte neu aufbauen; mm-Werte;
                                          Großschreibung L/W/T geht ebenfalls;
                                          fehlende Werte bleiben erhalten
     viewer.setProduct('cnc'|'breadboard'|'table', userInitiated)
                                          userInitiated = true stoppt den
                                          automatischen Produktwechsel
     viewer.resetView()                   Startansicht (auch per Doppelklick)

   Bedienelemente ohne eigenes Skript:
     Reiter  <button class="gw-3d-tab" data-product="cnc|breadboard|table">
             innerhalb .gw-hero-visual (oder Großeltern-Element)
     Größen  <button class="gw-3d-preset" data-l data-w> innerhalb eines
             Containers [data-gw3d-group]; optional [data-gw3d-spec]
             zeigt „nx × nz = N Gewinde M6“.

   Steuerung: Ziehen dreht frei (Azimut 360°, Höhe bis knapp unter
   die Platte), Mausrad / Pinch zoomt zur Zeigerposition, Doppelklick
   setzt die Ansicht zurück.

   Einpassung: Der Startabstand gilt je Höhenwinkel — das Bauteil liegt
   bei jeder Eigendrehung und jeder Kipplage ganz im Rahmen und wird
   senkrecht mittig gesetzt (versetzte Projektion, Drehpunkt bleibt die
   Bauteilmitte). Unten bleibt der Bedienhinweis (.gw-3d-hint) frei;
   übergelegten Karten im oberen Bereich weicht das Modell aus, soweit
   der Platz reicht. Am Startabstand oder weiter weg wird der Abstand
   beim Kippen mitgeführt, stark herangezoomt bleibt er fest.
   ============================================================ */
(function () {
  'use strict';

  // Safe to include more than once (hero + showcase + product page).
  if (window.GW3D) { window.GW3D.scan(); return; }

  var THREE_URL = 'https://unpkg.com/three@0.160.0/build/three.module.js';
  var threePromise = null;
  // NOTE: a dynamic import() inside this classic script is broken on some
  // storefronts (a third-party app shims it to require()). So we load Three
  // by injecting a real <script type="module">, which imports natively and
  // exposes window.THREE. This is immune to that interference.
  function injectThree(url, onerror) {
    var s = document.createElement('script');
    s.type = 'module';
    s.textContent = 'import * as T from "' + url + '"; window.THREE = T; window.dispatchEvent(new Event("gw-three-ready"));';
    s.onerror = onerror;
    (document.head || document.documentElement).appendChild(s);
  }
  function loadThree() {
    if (!threePromise) {
      threePromise = new Promise(function (resolve, reject) {
        if (window.THREE && window.THREE.WebGLRenderer) return resolve(window.THREE);
        var settled = false;
        function ok() { if (!settled && window.THREE) { settled = true; resolve(window.THREE); } }
        window.addEventListener('gw-three-ready', ok, { once: true });
        // Nur die Kopie aus dem Theme (gw-assets.liquid). Das CDN nur, wenn keine Theme-Adresse gesetzt ist — nie als
        // Rückfall nach einem Ladefehler: kein Nachladen von einem fremden Server ohne Einwilligung.
        var primary = (typeof window !== 'undefined' && window.GW_THREE_URL) ? window.GW_THREE_URL : THREE_URL;
        injectThree(primary, function () { if (!settled) { settled = true; reject(new Error('three load failed')); } });
        setTimeout(function () { if (!settled) { if (window.THREE) ok(); else { settled = true; reject(new Error('three timeout')); } } }, 15000);
      });
      threePromise.catch(function () { threePromise = null; });
    }
    return threePromise;
  }

  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var SMALL = !!(window.matchMedia && window.matchMedia('(max-width: 700px), (pointer: coarse)').matches);
  var PHI_MIN = 0.02, PHI_MAX = Math.PI - 0.02;

  function webglOK() {
    try {
      var c = document.createElement('canvas');
      return !!(window.WebGLRenderingContext &&
        (c.getContext('webgl') || c.getContext('experimental-webgl')));
    } catch (e) { return false; }
  }

  function num(v, d) { v = parseFloat(v); return isNaN(v) ? d : v; }
  function clamp(v, a, b) { return v < a ? a : (v > b ? b : v); }

  function sanitize(c) {
    c.L = clamp(c.L, 25, 3000);
    c.W = clamp(c.W, 25, 3000);
    c.T = clamp(c.T, 3, 100);
    c.pitch = clamp(c.pitch, 5, 200);
    return c;
  }

  function readCfg(host) {
    return sanitize({
      L: num(host.getAttribute('data-l'), 300),          // length (mm, X)
      W: num(host.getAttribute('data-w'), 300),          // width  (mm, Z)
      T: num(host.getAttribute('data-thickness'), 12.7), // thickness (mm, Y)
      pitch: num(host.getAttribute('data-pitch'), 25),
      autorotate: host.getAttribute('data-autorotate') !== '0'
    });
  }

  /* ============================================================
     Geometrie-Bausteine
     Konturen sind Punktlisten {x, y, nx, ny} gegen den Uhrzeigersinn,
     mit analytischer Außennormale (Bögen exakt, Geraden tangential).
     ============================================================ */
  // Startwinkel je Lochposition leicht versetzt: sonst liegen die Eckpunkte
  // gleicher Löcher einer Reihe exakt auf einer Linie, und die Triangulierung
  // erzeugt Kanten durch fremde Eckpunkte (sichtbare Pixelrisse).
  function spin(x, y, n) {
    var h = Math.sin(x * 12.9898 + y * 78.233) * 43758.5453;
    return (h - Math.floor(h)) * Math.PI * 2 / n;
  }
  function cCircle(cx, cy, r, n, a0) {
    var o = [];
    if (a0 == null) a0 = spin(cx, cy, n);
    for (var i = 0; i < n; i++) {
      var a = a0 + i / n * Math.PI * 2, c = Math.cos(a), s = Math.sin(a);
      o.push({ x: cx + r * c, y: cy + r * s, nx: c, ny: s });
    }
    return o;
  }
  // Rechteck w × h mit Eckradius r (n Segmente je Ecke)
  function cRoundRect(cx, cy, w, h, r, n) {
    var o = [], hw = w / 2, hh = h / 2;
    r = Math.min(r, hw, hh);
    var cs = [[hw - r, -hh + r, -Math.PI / 2], [hw - r, hh - r, 0], [-hw + r, hh - r, Math.PI / 2], [-hw + r, -hh + r, Math.PI]];
    cs.forEach(function (k) {
      for (var i = 0; i <= n; i++) {
        var a = k[2] + i / n * Math.PI / 2, c = Math.cos(a), s = Math.sin(a);
        o.push({ x: cx + k[0] + r * c, y: cy + k[1] + r * s, nx: c, ny: s });
      }
    });
    return o;
  }
  // Wie cRoundRect (zentriert), zusätzlich Punkte auf den Geraden bei x = cutsX[i]
  // bzw. y = cutsY[i] — damit Wand und feldweise Deckel dieselben Eckpunkte teilen.
  function cRoundRectCuts(w, h, r, n, cutsX, cutsY) {
    var hw = w / 2, hh = h / 2, o = [];
    r = Math.min(r, hw, hh);
    function arc(cx, cy, a0) {
      for (var i = 0; i <= n; i++) { var a = a0 + i / n * Math.PI / 2, c = Math.cos(a), s = Math.sin(a); o.push({ x: cx + r * c, y: cy + r * s, nx: c, ny: s }); }
    }
    function line(list, fn) { list.forEach(function (v) { o.push(fn(v)); }); }
    var inX = cutsX.filter(function (v) { return v > -hw + r && v < hw - r; }).sort(function (p, q) { return p - q; });
    var inY = cutsY.filter(function (v) { return v > -hh + r && v < hh - r; }).sort(function (p, q) { return p - q; });
    arc(hw - r, -hh + r, -Math.PI / 2);
    line(inY, function (v) { return { x: hw, y: v, nx: 1, ny: 0 }; });
    arc(hw - r, hh - r, 0);
    line(inX.slice().reverse(), function (v) { return { x: v, y: hh, nx: 0, ny: 1 }; });
    arc(-hw + r, hh - r, Math.PI / 2);
    line(inY.slice().reverse(), function (v) { return { x: -hw, y: v, nx: -1, ny: 0 }; });
    arc(-hw + r, -hh + r, Math.PI);
    line(inX, function (v) { return { x: v, y: -hh, nx: 0, ny: -1 }; });
    return o;
  }
  // Polygon an einer achsparallelen Geraden zuschneiden; Schnittpunkte exakt auf der Geraden
  function clipPoly(P, ax, val, keepGreater) {
    var out = [], n = P.length;
    function inside(q) { return keepGreater ? q[ax] >= val - 1e-9 : q[ax] <= val + 1e-9; }
    function cut(S, E) {
      var t = (val - S[ax]) / (E[ax] - S[ax]), o = { x: S.x + (E.x - S.x) * t, y: S.y + (E.y - S.y) * t };
      o[ax] = val;
      return o;
    }
    for (var i = 0; i < n; i++) {
      var S = P[(i + n - 1) % n], E = P[i], si = inside(S), ei = inside(E);
      if (ei) { if (!si) out.push(cut(S, E)); out.push(E); }
      else if (si) out.push(cut(S, E));
    }
    return out;
  }
  function dedupe(P) {
    var out = [];
    P.forEach(function (q) {
      var l = out[out.length - 1];
      if (!l || Math.abs(l.x - q.x) > 1e-9 || Math.abs(l.y - q.y) > 1e-9) out.push(q);
    });
    while (out.length > 2 && Math.abs(out[0].x - out[out.length - 1].x) < 1e-9 && Math.abs(out[0].y - out[out.length - 1].y) < 1e-9) out.pop();
    return out;
  }
  // Langloch: Mittenabstand len, Breite wid, entlang y (vertical) oder x
  function cSlot(cx, cy, len, wid, n, alongY) {
    var o = [], r = wid / 2, h = len / 2;
    for (var e = 0; e < 2; e++) {
      for (var i = 0; i <= n; i++) {
        var a = (alongY ? 0 : -Math.PI / 2) + (e ? Math.PI : 0) + i / n * Math.PI, c = Math.cos(a), s = Math.sin(a);
        var ox = alongY ? 0 : (e ? -h : h), oy = alongY ? (e ? -h : h) : 0;
        o.push({ x: cx + ox + r * c, y: cy + oy + r * s, nx: c, ny: s });
      }
    }
    return o;
  }

  // Kantenprofil einer senkrechten Wand. u = Versatz weg vom Material,
  // Rückgabe: Segmente [u0, y0, nu0, ny0, u1, y1, nu1, ny1].
  // Kantenarten: {k:'c', s} Fase · {k:'r', s, n} Rundung · {k:'f', s, n} Kehle
  function edgeProfile(bottom, top, y0, y1) {
    var segs = [];
    function flat(ua, ya, ub, yb) {
      var nu = yb - ya, ny = -(ub - ua), l = Math.sqrt(nu * nu + ny * ny) || 1;
      segs.push([ua, ya, nu / l, ny / l, ub, yb, nu / l, ny / l]);
    }
    function arc(fn, n) {
      for (var i = 0; i < n; i++) segs.push(fn(i / n).concat(fn((i + 1) / n)));
    }
    var yb = y0, yt = y1, H = Math.PI / 2;
    if (bottom) {
      var s = bottom.s, n = bottom.n || 4;
      if (bottom.k === 'c') flat(-s, y0, 0, y0 + s);
      else if (bottom.k === 'r') arc(function (t) { var b = t * H; return [-s + s * Math.sin(b), y0 + s - s * Math.cos(b), Math.sin(b), -Math.cos(b)]; }, n);
      else arc(function (t) { var b = t * H; return [s - s * Math.sin(b), y0 + s - s * Math.cos(b), Math.sin(b), Math.cos(b)]; }, n);
      yb = y0 + s;
    }
    if (top) yt = y1 - top.s;
    if (yt > yb + 1e-7) flat(0, yb, 0, yt);
    if (top) {
      var s2 = top.s, n2 = top.n || 4;
      if (top.k === 'c') flat(0, yt, -s2, y1);
      else if (top.k === 'r') arc(function (t) { var b = t * H; return [-s2 + s2 * Math.cos(b), y1 - s2 + s2 * Math.sin(b), Math.cos(b), Math.sin(b)]; }, n2);
      else arc(function (t) { var b = t * H; return [s2 - s2 * Math.cos(b), y1 - s2 + s2 * Math.sin(b), Math.cos(b), -Math.sin(b)]; }, n2);
    }
    return segs;
  }

  function GeoBuilder() { this.p = []; this.n = []; this.t = []; this.ix = [[], [], [], []]; this.count = 0; }
  GeoBuilder.prototype.v = function (x, y, z, nx, ny, nz, u, w) {
    this.p.push(x, y, z); this.n.push(nx, ny, nz); this.t.push(u, w);
    return this.count++;
  };
  // Streifen aus Punktpaaren (base + 2i, base + 2i + 1), i = 0..N.
  // Die Dreiecksrichtung folgt den Normalen (keine Annahme über Umlaufsinn).
  GeoBuilder.prototype.strip = function (base, N, mi) {
    var P = this.p, Nn = this.n, flip = false, found = false;
    for (var k = 0; k < N && !found; k++) {
      var a0 = base + 2 * k, a1 = a0 + 1, b0 = a0 + 2, b1 = a0 + 3;
      var ux = P[3 * b0] - P[3 * a0], uy = P[3 * b0 + 1] - P[3 * a0 + 1], uz = P[3 * b0 + 2] - P[3 * a0 + 2];
      var vx = P[3 * b1] - P[3 * a0], vy = P[3 * b1 + 1] - P[3 * a0 + 1], vz = P[3 * b1 + 2] - P[3 * a0 + 2];
      var cx = uy * vz - uz * vy, cy = uz * vx - ux * vz, cz = ux * vy - uy * vx;
      var wx = P[3 * a1] - P[3 * a0], wy = P[3 * a1 + 1] - P[3 * a0 + 1], wz = P[3 * a1 + 2] - P[3 * a0 + 2];
      cx += vy * wz - vz * wy; cy += vz * wx - vx * wz; cz += vx * wy - vy * wx;
      if (cx * cx + cy * cy + cz * cz < 1e-14) continue;
      var nx = Nn[3 * a0] + Nn[3 * b1], ny = Nn[3 * a0 + 1] + Nn[3 * b1 + 1], nz = Nn[3 * a0 + 2] + Nn[3 * b1 + 2];
      flip = (cx * nx + cy * ny + cz * nz) < 0; found = true;
    }
    var ix = this.ix[mi];
    for (var i = 0; i < N; i++) {
      var A0 = base + 2 * i, A1 = A0 + 1, B0 = A0 + 2, B1 = A0 + 3;
      if (flip) ix.push(A0, B1, B0, A0, A1, B1);
      else ix.push(A0, B0, B1, A0, B1, A1);
    }
  };
  GeoBuilder.prototype.cap = function (contours, faces, y, up, uvs, mi) {
    var base = this.count, ny = up ? 1 : -1, self = this, flat = [];
    contours.forEach(function (c) { c.forEach(function (p) { flat.push(p); self.v(p.x, y, p.y, 0, ny, 0, p.x * uvs, p.y * uvs); }); });
    var flip = false;
    for (var f = 0; f < faces.length; f++) {
      var a = flat[faces[f][0]], b = flat[faces[f][1]], c = flat[faces[f][2]];
      var cyv = (b.y - a.y) * (c.x - a.x) - (b.x - a.x) * (c.y - a.y);
      if (Math.abs(cyv) > 1e-12) { flip = (cyv * ny) < 0; break; }
    }
    var ix = this.ix[mi || 0];
    for (var j = 0; j < faces.length; j++) {
      var F = faces[j];
      if (flip) ix.push(base + F[0], base + F[2], base + F[1]);
      else ix.push(base + F[0], base + F[1], base + F[2]);
    }
  };
  GeoBuilder.prototype.build = function (THREE) {
    var g = new THREE.BufferGeometry(), all = [], start = 0;
    g.setAttribute('position', new THREE.Float32BufferAttribute(this.p, 3));
    g.setAttribute('normal', new THREE.Float32BufferAttribute(this.n, 3));
    g.setAttribute('uv', new THREE.Float32BufferAttribute(this.t, 2));
    for (var m = 0; m < this.ix.length; m++) {
      var a = this.ix[m];
      if (!a.length) continue;
      g.addGroup(start, a.length, m); start += a.length;
      for (var i = 0; i < a.length; i++) all.push(a[i]);
    }
    g.setIndex(all);
    g.computeBoundingBox(); g.computeBoundingSphere();
    return g;
  };

  // Prisma zwischen y0 und y1: Außenkontur + Bohrungen/Taschen, jede
  // Kontur mit eigener Ober-/Unterkante. wall:false = nur Deckel-
  // aussparung (Wand liefert ein anderes Bauteil). mi = Materialgruppe.
  function prism(THREE, o) {
    var B = new GeoBuilder(), y0 = o.y0, y1 = o.y1, uvs = o.uvs || 0.25;
    var items = [{ pts: o.outer, top: o.top, bottom: o.bottom, sgn: 1, wall: o.outerWall !== false, mi: 0, vs: uvs, ins: o.topInset || 0 }];
    (o.holes || []).forEach(function (h) {
      items.push({ pts: h.pts, top: h.top, bottom: h.bottom, sgn: -1, wall: h.wall !== false, mi: h.mi || 0, vs: h.vs || uvs, ins: h.capGrow || 0 });
    });
    var capT = [], capB = [], same = true;
    items.forEach(function (it) {
      var pts = it.pts, N = pts.length, sg = it.sgn;
      var prof = it.wall ? edgeProfile(it.bottom, it.top, y0, y1) : null;
      var uB = prof ? prof[0][0] : 0, uT = prof ? prof[prof.length - 1][4] : 0;
      if (Math.abs(uB - uT) > 1e-9) same = false;
      if (prof) {
        var acc = [0];
        for (var i = 1; i <= N; i++) { var a = pts[i - 1], b = pts[i % N]; acc.push(acc[i - 1] + Math.sqrt((b.x - a.x) * (b.x - a.x) + (b.y - a.y) * (b.y - a.y))); }
        prof.forEach(function (s) {
          var base = B.count;
          for (var i = 0; i <= N; i++) {
            var p = pts[i % N], nx = p.nx * sg, nz = p.ny * sg;
            B.v(p.x + nx * s[0], s[1], p.y + nz * s[0], nx * s[2], s[3], nz * s[2], acc[i] * uvs, s[1] * it.vs);
            B.v(p.x + nx * s[4], s[5], p.y + nz * s[4], nx * s[6], s[7], nz * s[6], acc[i] * uvs, s[5] * it.vs);
          }
          B.strip(base, N, it.mi);
        });
      }
      // ins: Deckel weicht von der Wand zurück (verdeckter Stoß zum nächsten Bauteil)
      var ins = it.ins;
      if (ins) same = false;
      capT.push(pts.map(function (p) { return new THREE.Vector2(p.x + p.nx * sg * (uT - ins), p.y + p.ny * sg * (uT - ins)); }));
      capB.push(pts.map(function (p) { return new THREE.Vector2(p.x + p.nx * sg * uB, p.y + p.ny * sg * uB); }));
    });
    var fT = null;
    if (o.capTop !== false) {
      fT = THREE.ShapeUtils.triangulateShape(capT[0], capT.slice(1));
      B.cap(capT, fT, y1, true, uvs);
    }
    if (o.capBottom !== false) {
      var fB = (same && fT) ? fT : THREE.ShapeUtils.triangulateShape(capB[0], capB.slice(1));
      B.cap(capB, fB, y0, false, uvs);
    }
    return B.build(THREE);
  }

  // Rotationskörper aus Profilsegmenten (Radius r, Höhe y).
  // Ebenes Segment: rs(r0, y0, r1, y1, mi). Normale = (dy, −dr):
  // Bohrungsprofile von oben nach unten → Normale zeigt in die Bohrung.
  function rs(r0, y0, r1, y1, mi) {
    var nr = y1 - y0, ny = -(r1 - r0), l = Math.sqrt(nr * nr + ny * ny) || 1;
    return [r0, y0, nr / l, ny / l, r1, y1, nr / l, ny / l, mi || 0];
  }
  function revolve(THREE, segs, N, vScale, a0) {
    var B = new GeoBuilder();
    a0 = a0 || 0;
    segs.forEach(function (s) {
      var base = B.count;
      for (var k = 0; k <= N; k++) {
        var a = a0 + k / N * Math.PI * 2, ca = Math.cos(a), sa = Math.sin(a);
        B.v(s[0] * ca, s[1], s[0] * sa, s[2] * ca, s[3], s[2] * sa, k / N, s[1] * vScale);
        B.v(s[4] * ca, s[5], s[4] * sa, s[6] * ca, s[7], s[6] * sa, k / N, s[5] * vScale);
      }
      B.strip(base, N, s[8] || 0);
    });
    return B.build(THREE);
  }

  /* ---------- Material-Erweiterungen (Shader-Einschübe) ----------
     ao:   Abdunklung in Bohrungen nach Tiefe (lokales y), {top, bot, k, min}
     mill: feine Bearbeitungsspuren über die Rauheit (nur WebGL2)        */
  function patchMat(mat, opt) {
    var key = JSON.stringify(opt);
    mat.onBeforeCompile = function (sh) {
      var vDecl = 'varying vec3 vGwP;\nvarying vec3 vGwN;\n';
      sh.vertexShader = sh.vertexShader
        .replace('#include <common>', '#include <common>\n' + vDecl)
        .replace('#include <begin_vertex>', '#include <begin_vertex>\nvGwP = position;\nvGwN = normal;');
      var f = '';
      if (opt.mill) {
        f += [
          '{',
          '  vec3 gn = normalize(vGwN);',
          '  float upF = smoothstep(0.86, 0.98, abs(gn.y));',
          '  float sideF = 1.0 - smoothstep(0.15, 0.45, abs(gn.y));',
          '  float dz = vGwP.z - (' + opt.mill.z.toFixed(3) + ');',
          '  float s1 = (vGwP.x - sqrt(max(' + (opt.mill.r * opt.mill.r).toFixed(3) + ' - dz * dz, 0.0))) / ' + opt.mill.f.toFixed(4) + ';',
          '  float w1 = clamp(1.0 - fwidth(s1) * 1.6, 0.0, 1.0);',
          '  float m1 = 0.5 + 0.5 * cos(s1 * 6.2831853);',
          '  float s2 = vGwP.y / ' + opt.mill.side.toFixed(4) + ';',
          '  float w2 = clamp(1.0 - fwidth(s2) * 1.6, 0.0, 1.0);',
          '  float m2 = 0.5 + 0.5 * cos(s2 * 6.2831853);',
          '  roughnessFactor = clamp(roughnessFactor + upF * w1 * (m1 - 0.5) * ' + opt.mill.a.toFixed(3) + ' + sideF * w2 * (m2 - 0.5) * ' + (opt.mill.a * 0.6).toFixed(3) + ', 0.04, 1.0);',
          '}'
        ].join('\n');
      }
      var a = '';
      if (opt.ao) {
        a = [
          '{',
          '  float gwD = min(' + opt.ao.top.toFixed(4) + ' - vGwP.y, vGwP.y - (' + opt.ao.bot.toFixed(4) + '));',
          '  float gwAO = ' + opt.ao.min.toFixed(3) + ' + ' + (1 - opt.ao.min).toFixed(3) + ' * exp(-max(gwD, 0.0) / ' + opt.ao.k.toFixed(4) + ');',
          '  reflectedLight.directDiffuse *= gwAO; reflectedLight.indirectDiffuse *= gwAO;',
          '  reflectedLight.directSpecular *= gwAO; reflectedLight.indirectSpecular *= gwAO;',
          '}'
        ].join('\n');
      }
      sh.fragmentShader = sh.fragmentShader
        .replace('#include <common>', '#include <common>\n' + vDecl)
        .replace('#include <roughnessmap_fragment>', '#include <roughnessmap_fragment>\n' + f)
        .replace('#include <aomap_fragment>', '#include <aomap_fragment>\n' + a);
    };
    mat.customProgramCacheKey = function () { return 'gw3d' + key; };
    return mat;
  }

  // Gewinde-Anmutung: Normalenkarte mit Rillen, eine Steigung je Kachel (v)
  function threadTexture(THREE) {
    var H = 64, c = document.createElement('canvas');
    c.width = 4; c.height = H;
    var g = c.getContext('2d'), img = g.createImageData(4, H);
    for (var y = 0; y < H; y++) {
      var t = y / H, sl = Math.max(-1, Math.min(1, Math.sin(t * Math.PI * 2) * 2.2));
      var ny = -sl * 0.9, nz = 1, l = Math.sqrt(ny * ny + nz * nz);
      var G = Math.round((ny / l * 0.5 + 0.5) * 255), Bv = Math.round((nz / l * 0.5 + 0.5) * 255);
      for (var x = 0; x < 4; x++) { var i = (y * 4 + x) * 4; img.data[i] = 128; img.data[i + 1] = G; img.data[i + 2] = Bv; img.data[i + 3] = 255; }
    }
    g.putImageData(img, 0, 0);
    var tex = new THREE.CanvasTexture(c);
    tex.wrapS = tex.wrapT = THREE.RepeatWrapping;
    return tex;
  }

  // Weicher Bodenschatten als Textur (Rechteck mit Unschärfe)
  function blobTexture(THREE) {
    var S = 256, c = document.createElement('canvas');
    c.width = c.height = S;
    var g = c.getContext('2d');
    g.fillStyle = '#000';
    g.shadowColor = 'rgba(0,0,0,1)';
    g.shadowBlur = 34;
    g.shadowOffsetX = S * 4;
    var m = S * 0.2;
    g.fillRect(m - S * 4, m, S - 2 * m, S - 2 * m);
    var tex = new THREE.CanvasTexture(c);
    tex.colorSpace = THREE.SRGBColorSpace;
    return tex;
  }

  /* ---------- Viewer ---------- */
  function Viewer(host, THREE) {
    this.host = host;
    this.T = THREE;
    this.cfg = readCfg(host);
    // Optional product showcase: data-showcase="breadboard,table,cnc"
    this.products = (host.getAttribute('data-showcase') || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    this.product = this.products[0] || 'breadboard';
    this.autoCycle = this.products.length > 1;
    this.raf = 0;
    this.visible = true;
    this.dragging = false;
    this.lastT = 0;
    this._build();
  }

  Viewer.prototype._build = function () {
    var THREE = this.T, host = this.host;

    var renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true, powerPreference: 'high-performance' });
    renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
    renderer.outputColorSpace = THREE.SRGBColorSpace;
    renderer.toneMapping = THREE.ACESFilmicToneMapping;
    renderer.toneMappingExposure = 1.05;
    renderer.shadowMap.enabled = true;
    renderer.shadowMap.type = THREE.VSMShadowMap;
    renderer.shadowMap.autoUpdate = false;
    this.renderer = renderer;
    this.webgl2 = !!(renderer.capabilities && renderer.capabilities.isWebGL2);

    var holder = document.createElement('div');
    holder.className = 'gw-3d-canvas';
    holder.appendChild(renderer.domElement);
    host.appendChild(holder);

    var scene = new THREE.Scene();
    this.scene = scene;

    // Studio-Umgebung für glaubwürdige Metallreflexe.
    this._env(THREE, renderer, scene);

    var cam = new THREE.PerspectiveCamera(30, 1, 0.05, 2000);
    this.cam = cam;

    var hemi = new THREE.HemisphereLight(0xe6eefa, 0x2b313b, 0.35); scene.add(hemi);
    var key = new THREE.DirectionalLight(0xffffff, 1.5);
    key.castShadow = true;
    key.shadow.mapSize.set(SMALL ? 1024 : 2048, SMALL ? 1024 : 2048);
    key.shadow.radius = 9;
    key.shadow.blurSamples = 16;
    key.shadow.bias = -0.0004;
    scene.add(key); scene.add(key.target);
    this.key = key;
    var rim = new THREE.DirectionalLight(0xc4d4ff, 0.55); rim.position.set(-55, 30, -45); scene.add(rim);

    // Boden: Schlagschatten + weicher Kontaktschatten (nur von oben sichtbar)
    this.shadowMat = new THREE.ShadowMaterial({ opacity: 0.2, transparent: true, depthWrite: false });
    this.ground = new THREE.Mesh(new THREE.PlaneGeometry(1, 1), this.shadowMat);
    this.ground.rotation.x = -Math.PI / 2;
    this.ground.receiveShadow = true;
    this.ground.renderOrder = 1;
    scene.add(this.ground);
    this.blobTex = blobTexture(THREE);
    this.blobMat = new THREE.MeshBasicMaterial({ map: this.blobTex, color: 0x10161f, transparent: true, depthWrite: false, opacity: 0.5 });
    this.blob = new THREE.Mesh(new THREE.PlaneGeometry(1, 1), this.blobMat);
    this.blob.rotation.x = -Math.PI / 2;
    this.blob.renderOrder = 0;
    scene.add(this.blob);

    this.threadTex = threadTexture(THREE);

    this.group = new THREE.Group();
    scene.add(this.group);

    // Kugelkoordinaten um einen Zielpunkt (Azimut theta, Polarwinkel phi ab +Y)
    this.theta = -0.62;
    this.phi = 0.95;
    this.tTheta = this.theta;
    this.tPhi = this.phi;
    this.radius = 100; this.tRadius = 100; this.minR = 10; this.maxR = 400; this.homeR = 100;
    this.target = new THREE.Vector3(); this.tTarget = new THREE.Vector3();
    this.fitR = 40;
    this.box = new THREE.Box3();
    this._v1 = new THREE.Vector3();
    this.ray = new THREE.Raycaster();

    this._resize();
    this._buildProduct(this.product);
    this._applyView(this.product);

    this._bindControls();

    this._ro = new ResizeObserver(this._resize.bind(this));
    this._ro.observe(host);

    var self = this;
    this._io = new IntersectionObserver(function (ents) {
      self.visible = ents[0].isIntersecting;
      if (self.visible) self._start(); else self._stop();
    }, { threshold: 0.01 });
    this._io.observe(host);

    this._start();
    requestAnimationFrame(function () { host.classList.add('gw-3d-ready'); });
    this._syncTabs();
  };

  /* ---------- Product showcase (breadboard / table / cnc) ---------- */
  Viewer.prototype._buildProduct = function (kind) {
    this._disposables = [];
    if (kind === 'table') this._table();
    else if (kind === 'cnc') this._cncPart();
    else this._board();
  };

  Viewer.prototype._viewFor = function (kind) {
    // phi = Start-Höhenwinkel, near = kleinster Abstand relativ zur Hüllkugel
    if (kind === 'table') return { phi: 1.16, near: 0.45 };
    if (kind === 'cnc') return { phi: 0.98, near: 0.4 };
    return { phi: 0.92, near: 0.11 };
  };

  Viewer.prototype._applyView = function (kind) {
    var v = this._viewFor(kind);
    this.tPhi = v.phi;
    this._frameToGroup(false, v.near);
  };

  // Zentrieren, Kameraabstand und Bühne (Boden, Schatten) an das Modell anpassen.
  // Der Startabstand hängt nur von Modell, Rahmen und Höhenwinkel ab (_fitAt),
  // nicht vom Weg dorthin: Größenwechsel, Doppelklick und Resize ergeben dieselbe Ansicht.
  Viewer.prototype._frameToGroup = function (smooth, near) {
    var THREE = this.T;
    this.group.position.set(0, 0, 0);
    var box = new THREE.Box3().setFromObject(this.group);
    if (box.isEmpty()) return;
    var sph = box.getBoundingSphere(new THREE.Sphere());
    this.group.position.set(-sph.center.x, -sph.center.y, -sph.center.z);
    box.translate(this.group.position);
    this.box.copy(box);
    var r = sph.radius || 40;
    this.fitR = r;
    this._hullPts = this._hullPoints();
    this._buildFit();
    this.homeR = this._fitAt(this.tPhi);
    this.tRadius = this.homeR;
    if (!smooth) this.radius = this.tRadius;
    this.minR = r * (near || 0.3);
    this.maxR = Math.max(this.homeR * 1.6, r * 3);
    this.tTarget.set(0, 0, 0);
    if (!smooth) this.target.set(0, 0, 0);
    this._stage(box, r);
  };

  // Rahmen in NDC: waagrecht ±x, senkrecht +t / −b (hart, bestimmt den Abstand),
  // st = weiche Obergrenze (nur für die Lage). Unten hält b den Bedienhinweis
  // frei; st weicht übergelegten Karten/Schildern im oberen Bereich aus.
  Viewer.prototype._measure = function () {
    var L = { x: 0.92, t: 0.88, b: 0.88, st: 0.88 }, host = this.host;
    var hr = host.getBoundingClientRect ? host.getBoundingClientRect() : null;
    this._lim = L;
    if (!hr || !(hr.width > 0) || !(hr.height > 0)) return;
    var gap = 6, H = hr.height, A = hr.width * hr.height;
    function shown(el, r) {
      if (!(r.width > 0) || !(r.height > 0)) return false;
      var cs = window.getComputedStyle ? window.getComputedStyle(el) : null;
      return !cs || (cs.display !== 'none' && cs.visibility !== 'hidden' && parseFloat(cs.opacity || '1') > 0.05);
    }
    var hint = host.querySelector('.gw-3d-hint');
    if (hint) {
      var q = hint.getBoundingClientRect();
      if (shown(hint, q) && q.top > hr.top + H / 2 && q.top < hr.bottom) L.b = clamp(1 - 2 * (hr.bottom - q.top + gap) / H, 0.55, 0.88);
    }
    var cand = [].slice.call(host.querySelectorAll('.gw-3d-badge'));
    [host.parentElement, host.parentElement && host.parentElement.parentElement].forEach(function (p) {
      if (!p || !p.children) return;
      [].forEach.call(p.children, function (el) { if (el !== host && !el.contains(host)) cand.push(el); });
    });
    cand.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (!shown(el, r) || r.width * r.height > A * 0.4) return;            // flächige Ebenen (Foto, Ersatzbild) zählen nicht
      var cs = window.getComputedStyle ? window.getComputedStyle(el) : null;
      if (cs && cs.position !== 'absolute' && cs.position !== 'fixed') return;
      var ix = Math.min(r.right, hr.right) - Math.max(r.left, hr.left), iy = Math.min(r.bottom, hr.bottom) - Math.max(r.top, hr.top);
      if (ix <= 0 || iy <= 0 || r.top + r.height / 2 > hr.top + H / 2) return; // nur Überlagerungen der oberen Hälfte
      L.st = Math.min(L.st, clamp(1 - 2 * (r.bottom - hr.top + gap) / H, 0.1, 0.88));
    });
  };

  // Stützpunkte der Modellhülle: Extrempunkte der Eckpunkte in 82 Richtungen,
  // Koordinaten relativ zur Bauteilmitte. Instanzgruppen, als gwHullBox
  // markierte Netze (Plattendeckel) und sehr große Netze gehen mit den Ecken
  // ihres Hüllquaders ein.
  Viewer.prototype._hullPoints = function () {
    var THREE = this.T, dirs = [], best = [], bestV = [], out = [];
    for (var e = -2; e <= 2; e++) {
      var el = e * Math.PI / 6, ce = Math.cos(el), se = Math.sin(el);
      for (var a = 0; a < 16; a++) { var az = a / 16 * Math.PI * 2; dirs.push([ce * Math.cos(az), se, ce * Math.sin(az)]); }
    }
    dirs.push([0, 1, 0], [0, -1, 0]);
    for (var i = 0; i < dirs.length; i++) { bestV.push(-Infinity); best.push(null); }
    function take(x, y, z) {
      for (var i = 0; i < dirs.length; i++) {
        var d = dirs[i], s = x * d[0] + y * d[1] + z * d[2];
        if (s > bestV[i]) { bestV[i] = s; best[i] = [x, y, z]; }
      }
    }
    var v = new THREE.Vector3(), bb = new THREE.Box3();
    this.group.updateMatrixWorld(true);
    this.group.children.forEach(function (ch) {
      var g = ch.geometry, pa = g && g.attributes && g.attributes.position;
      if (!pa) return;
      if (ch.isInstancedMesh || (ch.userData && ch.userData.gwHullBox) || pa.count > 20000) {
        if (ch.isInstancedMesh && ch.computeBoundingBox) { ch.computeBoundingBox(); bb.copy(ch.boundingBox); }
        else { if (!g.boundingBox) g.computeBoundingBox(); bb.copy(g.boundingBox); }
        if (bb.isEmpty()) return;
        bb.applyMatrix4(ch.matrixWorld);
        for (var c = 0; c < 8; c++) take(c & 1 ? bb.max.x : bb.min.x, c & 2 ? bb.max.y : bb.min.y, c & 4 ? bb.max.z : bb.min.z);
        return;
      }
      for (var k = 0; k < pa.count; k++) { v.fromBufferAttribute(pa, k).applyMatrix4(ch.matrixWorld); take(v.x, v.y, v.z); }
    });
    var seen = {};
    best.forEach(function (p) {
      if (!p) return;
      var key = p[0].toFixed(5) + ',' + p[1].toFixed(5) + ',' + p[2].toFixed(5);
      if (!seen[key]) { seen[key] = 1; out.push(p); }
    });
    return out.length ? out : null;
  };

  // Senkrechte NDC-Grenzen (ohne Versatz) und größte waagrechte Auslenkung der
  // Hüllpunkte über eine volle Eigendrehung (nAz Schritte), Höhe phi, Abstand R zur Mitte.
  Viewer.prototype._extent = function (phi, R, nAz) {
    var cam = this.cam, P = this._hullPts;
    if (!P) {
      var b = this.box; P = [];
      for (var c = 0; c < 8; c++) P.push([c & 1 ? b.max.x : b.min.x, c & 2 ? b.max.y : b.min.y, c & 4 ? b.max.z : b.min.z]);
    }
    var tv = Math.tan(cam.fov * Math.PI / 360), th = tv * (cam.aspect || 1), n = P.length;
    var sp = Math.sin(phi), cp = Math.cos(phi), ymin = Infinity, ymax = -Infinity, xmax = 0, bad = false;
    var NA = nAz || 36;
    for (var s = 0; s < NA; s++) {
      var t = s / NA * Math.PI * 2, st = Math.sin(t), ct = Math.cos(t);
      // Blickrichtung zur Kamera d, rechts r = (cos t, 0, −sin t), oben u = d × r
      var dx = sp * st, dy = cp, dz = sp * ct;
      var rx = ct, rz = -st;
      var ux = dy * rz, uy = dz * rx - dx * rz, uz = -dy * rx;
      for (var i = 0; i < n; i++) {
        var x = P[i][0], y = P[i][1], z = P[i][2];
        var w = R - (x * dx + y * dy + z * dz);
        if (w < 1e-6) { bad = true; continue; }
        var px = Math.abs(x * rx + z * rz) / (w * th), py = (x * ux + y * uy + z * uz) / (w * tv);
        if (px > xmax) xmax = px;
        if (py < ymin) ymin = py;
        if (py > ymax) ymax = py;
      }
    }
    return { ymin: ymin, ymax: ymax, xmax: xmax, bad: bad };
  };

  // Kleinster Abstand, bei dem die Hülle in jeder Drehlage in den harten Rahmen
  // passt (senkrecht mit Versatz, daher zählt die Spannweite). guess = Startwert.
  Viewer.prototype._fitDistance = function (phi, guess) {
    var L = this._lim || { x: 0.92, t: 0.88, b: 0.88 }, self = this;
    function ok(R) { var e = self._extent(phi, R, 24); return !e.bad && e.xmax <= L.x && (e.ymax - e.ymin) <= L.t + L.b; }
    var g = guess > 0 ? guess : Math.max(this.fitR, 1e-3) * 3, lo = g * 0.8, hi = g * 1.25, n = 0;
    while (!ok(hi) && n++ < 40) { lo = hi; hi *= 1.5; }
    n = 0;
    while (lo > 1e-6 && ok(lo) && n++ < 40) { hi = lo; lo *= 0.67; }
    for (var i = 0; i < 12; i++) { var m = (lo + hi) / 2; if (ok(m)) hi = m; else lo = m; }
    return hi;
  };

  // Tabelle Startabstand über den ganzen erreichbaren Höhenbereich.
  Viewer.prototype._buildFit = function () {
    var n = 25, tab = [], prev = 0;
    if (!this._lim) this._measure();
    for (var i = 0; i < n; i++) { prev = this._fitDistance(PHI_MIN + (PHI_MAX - PHI_MIN) * i / (n - 1), prev); tab.push(prev); }
    this._fitTab = tab;
  };

  Viewer.prototype._fitAt = function (phi) {
    var t = this._fitTab;
    if (!t || !t.length) return this.fitR * 3;
    var u = (clamp(phi, PHI_MIN, PHI_MAX) - PHI_MIN) / (PHI_MAX - PHI_MIN) * (t.length - 1);
    var i = Math.min(t.length - 2, Math.floor(u)), f = u - i;
    return t[i] + (t[i + 1] - t[i]) * f;
  };

  // Startabstand für die Ziel-Höhe nachführen. Am Startabstand oder weiter weg
  // wird der Abstand verhältnisgleich mitgeführt (Bauteil bleibt ganz im Bild),
  // stark herangezoomt (unter 60 %) bleibt er fest (Drehen um das Detail);
  // dazwischen gleitender Übergang, damit nichts springt.
  Viewer.prototype._syncHome = function () {
    var h = this._fitAt(this.tPhi);
    if (!(h > 0)) return;
    if (this.homeR > 0 && Math.abs(h - this.homeR) > 1e-9) {
      var w = clamp((this.tRadius / this.homeR - 0.6) / 0.4, 0, 1);
      if (w > 0) this.tRadius *= Math.pow(h / this.homeR, w);
    }
    this.homeR = h;
    this.maxR = Math.max(h * 1.6, this.fitR * 3);
  };

  // Senkrechter Bildversatz (NDC, + = Modell nach oben) für Höhe phi und Abstand R:
  // mittig im weichen Rahmen, notfalls so wenig darüber wie der harte Rahmen erlaubt.
  // Ergebnis wird gemerkt, solange Höhe, Abstand und Einpassung gleich bleiben (Eigendrehung).
  Viewer.prototype._shiftFor = function (phi, R) {
    var k = this._shC;
    if (k && k.phi === phi && k.R === R && k.tab === this._fitTab) return k.v;
    var L = this._lim || { t: 0.88, b: 0.88, st: 0.88 }, e = this._extent(phi, R), v;
    if (e.bad || !isFinite(e.ymin)) v = 0;
    else {
      var c = (e.ymin + e.ymax) / 2, st = Math.min(L.st, L.t);
      var want = (st - L.b) / 2 - c, lo = -L.b - e.ymin, hi = L.t - e.ymax;
      v = lo > hi ? (L.t - L.b) / 2 - c : clamp(want, lo, hi);
    }
    this._shC = { phi: phi, R: R, tab: this._fitTab, v: v };
    return v;
  };

  // Kamera aus Kugelkoordinaten setzen (auch für Prüfskripte nutzbar).
  Viewer.prototype._placeCamera = function () {
    var cam = this.cam, sinP = Math.sin(this.phi);
    var dv = this._v1.set(sinP * Math.sin(this.theta), Math.cos(this.phi), sinP * Math.cos(this.theta));
    var r = this._clearance(this.target, dv, this.radius);
    cam.position.copy(this.target).addScaledVector(dv, r);
    cam.near = Math.max(0.02, r * 0.02);
    cam.far = r + this.fitR * 8;
    // Versatz am Startabstand der aktuellen Höhe; herangezoomt unverändert,
    // damit der Zoom zum Zeiger stabil bleibt.
    var sh = (this.box && !this.box.isEmpty()) ? this._shiftFor(this.phi, Math.max(this.radius, this._fitAt(this.phi))) : 0;
    var asp = cam.aspect || 1;
    cam.setViewOffset(asp, 1, 0, sh / 2, asp, 1);   // ruft updateProjectionMatrix auf
    cam.lookAt(this.target);
    return r;
  };

  Viewer.prototype._stage = function (box, r) {
    var gy = box.min.y - r * 0.002;
    var sx = box.max.x - box.min.x, sz = box.max.z - box.min.z;
    this.ground.position.set(0, gy, 0);
    this.ground.scale.set(r * 8, r * 8, 1);
    this.blob.position.set((box.max.x + box.min.x) / 2, gy + r * 0.001, (box.max.z + box.min.z) / 2);
    this.blob.scale.set(sx / 0.6 * 1.04, sz / 0.6 * 1.04, 1);
    this.groundY = gy;
    var k = this.key;
    k.position.set(r * 1.2, r * 4, r * 1.6);
    k.target.position.set(0, gy, 0);
    var sc = k.shadow.camera;
    sc.left = -r * 1.4; sc.right = r * 1.4; sc.top = r * 1.4; sc.bottom = -r * 1.4;
    sc.near = r * 0.5; sc.far = r * 9;
    sc.updateProjectionMatrix();
    k.target.updateMatrixWorld();
    this.renderer.shadowMap.needsUpdate = true;
  };

  Viewer.prototype._clear = function () {
    var g = this.group;
    while (g.children.length) {
      var ch = g.children.pop();
      if (ch.isInstancedMesh && ch.dispose) ch.dispose();
      if (ch.geometry && ch.geometry.dispose) ch.geometry.dispose();
    }
    (this._disposables || []).forEach(function (d) { if (d && d.dispose) d.dispose(); });
    this._disposables = [];
  };

  Viewer.prototype.setProduct = function (kind, userInitiated) {
    if (kind === this.product) { if (userInitiated) this.autoCycle = false; return; }
    this._clear();
    this.product = kind;
    this._buildProduct(kind);
    this._applyView(kind);
    this.idle = 0; this.cycleT = 0;
    if (userInitiated) this.autoCycle = false;
    this._syncTabs();
  };

  Viewer.prototype.resetView = function () {
    var v = this._viewFor(this.product);
    this.tPhi = v.phi;
    this.homeR = this._fitAt(this.tPhi);
    this.tRadius = this.homeR;
    this.maxR = Math.max(this.homeR * 1.6, this.fitR * 3);
    this.tTarget.set(0, 0, 0);
    this.idle = 0;
  };

  Viewer.prototype._syncTabs = function () {
    var wrap = (this.host.closest && this.host.closest('.gw-hero-visual')) || this.host.parentElement;
    if (!wrap || !wrap.querySelectorAll) return;
    var self = this;
    wrap.querySelectorAll('.gw-3d-tab').forEach(function (t) {
      t.classList.toggle('gw-active', t.getAttribute('data-product') === self.product);
    });
  };

  // ---- Labortisch (T-Nut-Aluprofil-Tisch) ----
  Viewer.prototype._table = function () {
    var THREE = this.T, g = this.group;
    var alu = new THREE.MeshStandardMaterial({ color: 0xb4bcc5, metalness: 0.85, roughness: 0.38 });
    var dark = new THREE.MeshStandardMaterial({ color: 0x71787f, metalness: 0.8, roughness: 0.48 });
    function box(w, h, d, x, y, z, m) {
      var me = new THREE.Mesh(new THREE.BoxGeometry(w, h, d), m || alu);
      me.position.set(x, y, z); me.castShadow = true; g.add(me); return me;
    }
    var L = 56, D = 34, H = 30, hw = L / 2, hd = D / 2;
    var legT = 3.6, fH = 4, fW = 2, slatH = 1.8;
    var lx = hw - legT / 2 - 0.4, lz = hd - legT / 2 - 0.4;
    var corners = [[lx, lz], [lx, -lz], [-lx, lz], [-lx, -lz]];
    corners.forEach(function (p) { box(legT, H, legT, p[0], H / 2, p[1], dark); });
    var fy = H - fH / 2;
    box(L, fH, fW, 0, fy, hd - fW / 2, alu);
    box(L, fH, fW, 0, fy, -(hd - fW / 2), alu);
    box(fW, fH, D - 2 * fW, hw - fW / 2, fy, 0, alu);
    box(fW, fH, D - 2 * fW, -(hw - fW / 2), fy, 0, alu);
    box(fW, fH, D - 2 * fW, -L * 0.22, fy, 0, alu);
    box(fW, fH, D - 2 * fW, L * 0.22, fy, 0, alu);
    var sy = H + slatH / 2, n = 10, sw = 3.5, pitch = (D - 3) / (n - 1), z0 = -((n - 1) / 2) * pitch;
    for (var i = 0; i < n; i++) box(L - 1, slatH, sw, 0, sy, z0 + i * pitch, alu);
    var ly = H * 0.28;
    box(fW, fH * 0.8, D - 2 * fW, lx, ly, 0, dark);
    box(fW, fH * 0.8, D - 2 * fW, -lx, ly, 0, dark);
    box(L - 2 * legT, fH * 0.8, fW, 0, ly, 0, dark);
    corners.forEach(function (p) {
      var f = new THREE.Mesh(new THREE.CylinderGeometry(1.5, 1.9, 1.6, 20), dark);
      f.position.set(p[0], -0.5, p[1]); f.castShadow = true; g.add(f);
    });
    this._disposables.push(alu, dark);
  };

  // ---- CNC-Teil: gefrästes Aluminium (Maße in 10 mm) ----
  // Grundkörper mit umlaufendem Absatz, Plateau mit Senkbohrungen,
  // gesenktem Langloch, Tasche und Passbohrungen; Bund mit Lagersitz,
  // Absatzbohrung und Gewinde-Lochkreis.
  Viewer.prototype._cncPart = function () {
    var THREE = this.T, g = this.group;
    var mill = this.webgl2 ? { z: -1.6, r: 6.5, f: 0.11, side: 0.035, a: 0.13 } : null;
    function aluMat(color, ao) {
      return patchMat(new THREE.MeshPhysicalMaterial({ color: color, metalness: 1, roughness: 0.3, envMapIntensity: 1.0 }), { mill: mill, ao: ao });
    }
    // Lokales y jedes Bauteils endet oben bei 0 → eine AO-Einstellung für alle Wände
    var alu = aluMat(0xd5d9de, null);
    var wallAO = aluMat(0xd5d9de, { top: 0, bot: -100, k: 0.45, min: 0.42 });
    var floor = aluMat(0xa9aeb5, null);
    var thread = patchMat(new THREE.MeshStandardMaterial({
      color: 0xc9ced4, metalness: 1, roughness: 0.38, normalMap: this.threadTex, normalScale: new THREE.Vector2(1, 1)
    }), { ao: { top: 0, bot: -100, k: 0.22, min: 0.18 } });
    var mats = [alu, thread, wallAO];
    this._disposables.push(alu, wallAO, floor, thread);
    function add(o, mat) {
      var top = o.y1, m;
      o.y0 -= top; o.y1 = 0;
      m = new THREE.Mesh(prism(THREE, o), mat || mats);
      m.position.y = top;
      m.castShadow = true;
      g.add(m);
      return m;
    }
    var NA = 10, NC = 96, NB = 40, NS = 24, NH = 28;
    var ch = function (s) { return { k: 'c', s: s }; };
    var cbXY = [[4.8, 2.4], [-4.8, 2.4], [4.8, -2.4], [-4.8, -2.4]];
    var dowels = [[1.9, 2.9], [-1.9, -2.9]];

    // Grundkörper 124 × 80 × 8, R8 (Deckel getrennt: Absatz + Böden)
    var holesL1 = [];
    cbXY.forEach(function (p) { holesL1.push({ pts: cCircle(p[0], p[1], 0.275, NH), top: ch(0.03), bottom: ch(0.04) }); });
    dowels.forEach(function (p) { holesL1.push({ pts: cCircle(p[0], p[1], 0.3, NH), bottom: ch(0.03) }); });
    holesL1.push({ pts: cCircle(0, 0, 1.2, NC), bottom: ch(0.08) });
    holesL1.push({ pts: cSlot(3.8, 0, 2.2, 0.66, NS, true), top: ch(0.03), bottom: ch(0.04) });
    add({ y0: 0, y1: 0.8, outer: cRoundRect(0, 0, 12.4, 8.0, 0.8, NA), bottom: ch(0.06), top: ch(0.05), holes: holesL1, capTop: false });
    // Absatz: zwischen Außenfase und Kehle des Plateaus
    add({ y0: 0.79, y1: 0.8, outer: cRoundRect(0, 0, 12.3, 7.9, 0.75, NA), outerWall: false, capBottom: false,
      holes: [{ pts: cRoundRect(0, 0, 11.56, 7.16, 0.58, NA), wall: false }] }, alu);
    // Böden in Senkungen, Langloch und Tasche (leicht abgedunkelt = Umgebungsverdeckung)
    cbXY.forEach(function (p) {
      add({ y0: 0.79, y1: 0.8, outer: cCircle(p[0], p[1], 0.5, NB), outerWall: false, capBottom: false,
        holes: [{ pts: cCircle(p[0], p[1], 0.305, NH), wall: false }] }, floor);
    });
    add({ y0: 0.79, y1: 0.8, outer: cSlot(3.8, 0, 2.2, 1.1, NS, true), outerWall: false, capBottom: false,
      holes: [{ pts: cSlot(3.8, 0, 2.2, 0.72, NS, true), wall: false }] }, floor);
    add({ y0: 0.79, y1: 0.8, outer: cRoundRect(-3.8, 0, 1.3, 3.4, 0.3, NA), outerWall: false, capBottom: false }, floor);

    // Plateau 114 × 70 × 6, R5, Kehle zum Absatz
    var holesL2 = [];
    cbXY.forEach(function (p) { holesL2.push({ pts: cCircle(p[0], p[1], 0.5, NB), top: ch(0.04), mi: 2 }); });
    dowels.forEach(function (p) { holesL2.push({ pts: cCircle(p[0], p[1], 0.3, NH), top: ch(0.03) }); });
    holesL2.push({ pts: cCircle(0, 0, 1.2, NC), capGrow: 0.1 });
    holesL2.push({ pts: cSlot(3.8, 0, 2.2, 1.1, NS, true), top: ch(0.04), mi: 2 });
    holesL2.push({ pts: cRoundRect(-3.8, 0, 1.5, 3.6, 0.4, NA), top: ch(0.04), bottom: { k: 'f', s: 0.1, n: 4 }, mi: 2 });
    add({ y0: 0.8, y1: 1.4, outer: cRoundRect(0, 0, 11.4, 7.0, 0.5, NA), bottom: { k: 'f', s: 0.08, n: 3 }, top: ch(0.08), holes: holesL2, capBottom: false });

    // Bund ⌀52: unterer Teil mit Kehle, Absatzbohrung ⌀24
    add({
      y0: 1.4, y1: 2.0, outer: cCircle(0, 0, 2.6, NC), bottom: { k: 'f', s: 0.2, n: 5 },
      holes: [{ pts: cCircle(0, 0, 1.2, NC), top: ch(0.05) }], capBottom: false, topInset: 0.15
    });
    // oberer Teil: Lagersitz ⌀32, 6 × M4 auf Lochkreis ⌀42
    var holesB2 = [{ pts: cCircle(0, 0, 1.6, NC), top: ch(0.08), mi: 2 }];
    for (var i = 0; i < 6; i++) {
      var a = Math.PI / 6 + i * Math.PI / 3;
      holesB2.push({ pts: cCircle(Math.cos(a) * 2.1, Math.sin(a) * 2.1, 0.165, 20), top: ch(0.035), mi: 1, vs: 1 / 0.07 });
    }
    add({ y0: 2.0, y1: 2.8, outer: cCircle(0, 0, 2.6, NC), top: ch(0.1), holes: holesB2, capBottom: false });
  };

  Viewer.prototype._env = function (THREE, renderer, scene) {
    // Kleine Lichtraum-Szene → PMREM → scene.environment.
    var env = new THREE.Scene(), trash = [];
    var sg = new THREE.SphereGeometry(10, 48, 24), pos = sg.attributes.position, cols = [];
    var cTop = new THREE.Color(0.62, 0.66, 0.72), cHor = new THREE.Color(0.36, 0.39, 0.44), cLow = new THREE.Color(0.2, 0.215, 0.235);
    var tmp = new THREE.Color();
    for (var i = 0; i < pos.count; i++) {
      var y = pos.getY(i) / 10;
      if (y >= 0) tmp.copy(cHor).lerp(cTop, Math.pow(y, 0.7));
      else tmp.copy(cHor).lerp(cLow, Math.min(1, Math.pow(-y, 0.5) * 1.15));
      cols.push(tmp.r, tmp.g, tmp.b);
    }
    sg.setAttribute('color', new THREE.Float32BufferAttribute(cols, 3));
    var sm = new THREE.MeshBasicMaterial({ side: THREE.BackSide, vertexColors: true });
    env.add(new THREE.Mesh(sg, sm));
    trash.push(sg, sm);
    function panel(w, h, x, y, z, I, tint) {
      var pg = new THREE.PlaneGeometry(w, h);
      var pm = new THREE.MeshBasicMaterial({ color: new THREE.Color(tint || 0xffffff).multiplyScalar(I), side: THREE.DoubleSide });
      var m = new THREE.Mesh(pg, pm);
      m.position.set(x, y, z); m.lookAt(0, 0, 0);
      env.add(m); trash.push(pg, pm);
    }
    panel(7, 7, 0, 9.2, 0.5, 4.2);                 // Deckenfeld
    panel(1.6, 8.5, 8.6, 2.4, 3.2, 6.5);           // Streiflicht rechts vorn
    panel(1.6, 8.5, -7.8, 2.8, -4.6, 3.4, 0xdfe8ff); // Streiflicht links hinten
    panel(9, 1.4, 0.5, 1.0, 9.4, 1.6);             // Aufheller vorn, flach
    panel(5, 2.2, -6.5, 6.5, 4.5, 2.4);            // Oberlicht links vorn
    panel(6, 6, 2.5, -9.2, 1.5, 1.5);              // heller Tisch (Licht von unten)
    var pm2 = new THREE.PMREMGenerator(renderer);
    this.envRT = pm2.fromScene(env, 0.035);
    scene.environment = this.envRT.texture;
    pm2.dispose();
    trash.forEach(function (t) { t.dispose(); });
  };

  // ---- Breadboard ----
  Viewer.prototype._board = function () {
    var THREE = this.T, cfg = this.cfg, g = this.group;
    // scene units = cm (mm/10)
    var L = cfg.L / 10, W = cfg.W / 10, T = cfg.T / 10, pitch = cfg.pitch / 10;
    var hw = L / 2, hd = W / 2, ht = T / 2;

    var plateMat = new THREE.MeshStandardMaterial({ color: 0x24262a, metalness: 0.6, roughness: 0.44, envMapIntensity: 1.0 });
    var edgeMat = new THREE.MeshStandardMaterial({ color: 0x35383e, metalness: 0.7, roughness: 0.32, envMapIntensity: 1.2 });
    // Unterseite: gleiche Oberfläche, stärker vom hellen Tisch angeleuchtet (sonst von unten fast schwarz)
    var underMat = new THREE.MeshStandardMaterial({ color: 0x2c2f34, metalness: 0.55, roughness: 0.5, envMapIntensity: 2.6 });
    var boreMat = patchMat(new THREE.MeshStandardMaterial({
      color: 0x5b6069, metalness: 0.9, roughness: 0.42, normalMap: this.threadTex, normalScale: new THREE.Vector2(1.1, 1.1)
    }), { ao: { top: ht, bot: -ht, k: 0.2, min: 0.1 } });
    var cbMat = patchMat(new THREE.MeshStandardMaterial({ color: 0x24262a, metalness: 0.6, roughness: 0.46 }), { ao: { top: ht, bot: -ht, k: 0.6, min: 0.2 } });
    this._disposables.push(plateMat, edgeMat, underMat, boreMat, cbMat);

    // ---- Lochbild ----
    var nx = Math.max(1, Math.round(cfg.L / cfg.pitch)), nz = Math.max(1, Math.round(cfg.W / cfg.pitch));
    var x0 = -((nx - 1) / 2) * pitch, z0 = -((nz - 1) / 2) * pitch;
    var nh = nx * nz;
    var N = nh > 2500 ? 12 : (nh > 900 ? 16 : 24), NM = 36;   // Kreisteilung je nach Lochzahl
    var c = 0.08;                       // Fase an den Gewinden (0,8 mm)
    var ce = Math.min(0.1, ht * 0.3);   // Fase an den Außenkanten
    var gr = 0.25, gch = gr + c;        // M6-Kernloch ⌀5,0
    var cbR = 0.55, boreR = 0.325, cbDepth = Math.min(0.64, T * 0.5);
    var mounts = [];
    if (L >= 10 && W >= 10) {
      var mx = hw - 2.5, mz = hd - 2.5;
      mounts.push([mx, mz], [mx, -mz], [-mx, mz], [-mx, -mz]);
    }
    if (L >= 6 && W >= 6) mounts.push([0, 0]);
    var grid = [], keep = cbR + c + gch + 0.06;
    for (var ix = 0; ix < nx; ix++) {
      for (var iz = 0; iz < nz; iz++) {
        var px = x0 + ix * pitch, pz = z0 + iz * pitch, clash = false;
        if (Math.abs(px) > hw - gch - ce - 0.05 || Math.abs(pz) > hd - gch - ce - 0.05) continue;
        for (var m = 0; m < mounts.length; m++) {
          var dx = px - mounts[m][0], dz = pz - mounts[m][1];
          if (dx * dx + dz * dz < keep * keep) { clash = true; break; }
        }
        if (!clash) grid.push([px, pz]);
      }
    }

    // ---- Platte: gefaste Außenkanten + Deckel in Feldern ----
    // Die Deckel werden feldweise trianguliert (je Feld wenige Löcher):
    // bei großen Platten ein Bruchteil der Rechenzeit einer Fläche mit
    // allen Löchern. Schnitte liegen mittig zwischen Lochreihen und nie in
    // einer Senkbohrung; die Außenkontur erhält dieselben Schnittpunkte.
    var mr = cbR + c + 0.05;
    function cuts(n0, p0, step, axis) {
      var out = [], k = 6, i = k - 1;
      while (i < n0 - 1) {
        var v = p0 + (i + 0.5) * step, ok = true;
        for (var m = 0; m < mounts.length; m++) if (Math.abs(v - mounts[m][axis]) < mr) { ok = false; break; }
        if (ok) { out.push(v); i += k; } else i++;
      }
      return out;
    }
    var cx = cuts(nx, x0, pitch, 0), czs = cuts(nz, z0, pitch, 1);
    var outline = cRoundRectCuts(L, W, 0.2, 4, cx, czs);
    var plate = new THREE.Mesh(prism(THREE, {
      y0: -ht, y1: ht, outer: outline, top: { k: 'c', s: ce }, bottom: { k: 'c', s: ce }, capTop: false, capBottom: false, uvs: 0.05
    }), plateMat);
    plate.castShadow = true;
    g.add(plate);
    var ring = outline.map(function (q) { return { x: q.x + q.nx * (-ce), y: q.y + q.ny * (-ce) }; });
    var CB = new GeoBuilder(), xs = [-Infinity].concat(cx, [Infinity]), zs = [-Infinity].concat(czs, [Infinity]);
    var holePts = grid.map(function (q) { return { c: q, pts: cCircle(q[0], q[1], gch, N) }; })
      .concat(mounts.map(function (q) { return { c: q, pts: cCircle(q[0], q[1], cbR + c, NM) }; }));
    for (var a = 0; a < xs.length - 1; a++) {
      for (var b = 0; b < zs.length - 1; b++) {
        var poly = ring;
        if (xs[a] > -Infinity) poly = clipPoly(poly, 'x', xs[a], true);
        if (xs[a + 1] < Infinity) poly = clipPoly(poly, 'x', xs[a + 1], false);
        if (zs[b] > -Infinity) poly = clipPoly(poly, 'y', zs[b], true);
        if (zs[b + 1] < Infinity) poly = clipPoly(poly, 'y', zs[b + 1], false);
        poly = dedupe(poly);
        if (poly.length < 3) continue;
        var cont = [poly.map(function (q) { return new THREE.Vector2(q.x, q.y); })];
        holePts.forEach(function (h) {
          if (h.c[0] > xs[a] && h.c[0] < xs[a + 1] && h.c[1] > zs[b] && h.c[1] < zs[b + 1]) cont.push(h.pts.map(function (q) { return new THREE.Vector2(q.x, q.y); }));
        });
        var faces = THREE.ShapeUtils.triangulateShape(cont[0], cont.slice(1));
        CB.cap(cont, faces, ht, true, 0.05);
        CB.cap(cont, faces, -ht, false, 0.05, 1);
      }
    }
    var caps = new THREE.Mesh(CB.build(THREE), [plateMat, underMat]);
    caps.castShadow = true;
    caps.userData.gwHullBox = true;   // Umriss liefert die Plattenwand; Deckel nur als Hüllquader
    g.add(caps);

    var im = new THREE.Matrix4();
    // ---- Gewindebohrungen (instanziert): Fase · Gewinde · Fase ----
    if (grid.length) {
      var hGeo = revolve(THREE, [
        rs(gch, ht, gr, ht - c, 0),
        rs(gr, ht - c, gr, -ht + c, 1),
        rs(gr, -ht + c, gch, -ht, 0)
      ], N, 1 / 0.1);
      var hMesh = new THREE.InstancedMesh(hGeo, [edgeMat, boreMat], grid.length);
      grid.forEach(function (p, i) { im.makeRotationY(-spin(p[0], p[1], N)); im.setPosition(p[0], 0, p[1]); hMesh.setMatrixAt(i, im); });
      hMesh.instanceMatrix.needsUpdate = true;
      hMesh.computeBoundingSphere && hMesh.computeBoundingSphere();
      g.add(hMesh);
    }
    // ---- Befestigungsbohrungen: Senkung ⌀11 + Durchgang ⌀6,5 ----
    if (mounts.length) {
      var c2 = 0.04;
      var mGeo = revolve(THREE, [
        rs(cbR + c, ht, cbR, ht - c, 0),
        rs(cbR, ht - c, cbR, ht - cbDepth, 2),
        rs(cbR, ht - cbDepth, boreR + c2, ht - cbDepth, 2),
        rs(boreR + c2, ht - cbDepth, boreR, ht - cbDepth - c2, 2),
        rs(boreR, ht - cbDepth - c2, boreR, -ht + c, 2),
        rs(boreR, -ht + c, boreR + c, -ht, 0),
        rs(boreR + c, -ht, cbR + c, -ht, 3)      // ebener Ring der Unterseite: gleiches Material wie die Unterseite
      ], NM, 1);
      var mMesh = new THREE.InstancedMesh(mGeo, [edgeMat, boreMat, cbMat, underMat], mounts.length);
      mounts.forEach(function (p, i) { im.makeRotationY(-spin(p[0], p[1], NM)); im.setPosition(p[0], 0, p[1]); mMesh.setMatrixAt(i, im); });
      mMesh.instanceMatrix.needsUpdate = true;
      mMesh.computeBoundingSphere && mMesh.computeBoundingSphere();
      g.add(mMesh);
    }
    this._holesInfo = { nx: nx, nz: nz, count: grid.length };
  };

  Viewer.prototype.setBoard = function (over) {
    over = over || {};
    function pick() { for (var i = 0; i < arguments.length; i++) if (over[arguments[i]] != null && over[arguments[i]] !== '') return over[arguments[i]]; return null; }
    var c = Object.assign({}, this.cfg), v;
    if ((v = pick('L', 'l', 'length')) != null) c.L = num(v, c.L);
    if ((v = pick('W', 'w', 'width')) != null) c.W = num(v, c.W);
    if ((v = pick('T', 't', 'thickness')) != null) c.T = num(v, c.T);
    if ((v = pick('pitch')) != null) c.pitch = num(v, c.pitch);
    this.cfg = sanitize(c);
    this._clear();
    var was = this.product;
    this.product = 'breadboard';
    this._buildProduct('breadboard');
    var vf = this._viewFor('breadboard');
    if (was !== 'breadboard') this.tPhi = vf.phi;
    this._frameToGroup(true, vf.near);
    this._syncTabs();
  };

  /* ---------- Steuerung ---------- */
  Viewer.prototype._pick = function (cx, cy) {
    var rect = this.renderer.domElement.getBoundingClientRect();
    if (!rect.width || !rect.height) return null;
    var ndc = { x: ((cx - rect.left) / rect.width) * 2 - 1, y: -((cy - rect.top) / rect.height) * 2 + 1 };
    this.ray.setFromCamera(ndc, this.cam);
    var hits = this.ray.intersectObjects(this.group.children, true);
    return hits.length ? hits[0].point.clone() : null;
  };

  Viewer.prototype._zoomAt = function (cx, cy, factor, hit) {
    var oldR = this.tRadius, newR = clamp(oldR * factor, this.minR, this.maxR);
    if (newR < oldR - 1e-6) {
      if (hit === undefined) hit = (cx != null) ? this._pick(cx, cy) : null;
      if (hit) {
        this.tTarget.lerp(hit, 1 - newR / oldR);
        var lim = this.fitR * 0.95;
        if (this.tTarget.length() > lim) this.tTarget.setLength(lim);
      }
    } else if (newR > oldR + 1e-6) {
      // beim Herauszoomen zurück zur Mitte, spätestens beim Startabstand
      var k = oldR >= this.homeR ? 1 : Math.min(1, (newR - oldR) / Math.max(1e-6, this.homeR - oldR));
      this.tTarget.multiplyScalar(1 - k);
    }
    this.tRadius = newR;
  };

  Viewer.prototype._bindControls = function () {
    var el = this.renderer.domElement, self = this;
    var pts = new Map(), pinchD = 0, lastTap = 0, pinchHit = null;
    el.style.touchAction = 'none';
    function two() { var a = Array.from(pts.values()); return Math.hypot(a[0].x - a[1].x, a[0].y - a[1].y); }
    function mid() { var a = Array.from(pts.values()); return { x: (a[0].x + a[1].x) / 2, y: (a[0].y + a[1].y) / 2 }; }
    function down(e) {
      pts.set(e.pointerId, { x: e.clientX, y: e.clientY }); self.idle = 0;
      self.autoCycle = false;                    // wer selbst dreht, behält sein Modell
      if (pts.size === 1) {
        self.dragging = true;
        if (e.pointerType === 'touch') {           // Doppeltipp = Startansicht
          var now = Date.now();
          if (now - lastTap < 300) self.resetView();
          lastTap = now;
        }
      } else if (pts.size === 2) {
        self.dragging = false; pinchD = two();
        var m0 = mid(); pinchHit = self._pick(m0.x, m0.y);   // Zielpunkt einmal je Geste
      }
      try { if (el.setPointerCapture && e.pointerId != null) el.setPointerCapture(e.pointerId); } catch (e3) { /* Zeiger bereits gelöst */ }
    }
    function move(e) {
      var p = pts.get(e.pointerId); if (!p) return; self.idle = 0;
      if (pts.size >= 2) {                       // Zwei Finger: Pinch-Zoom zur Fingermitte
        p.x = e.clientX; p.y = e.clientY;
        var nd = two();
        if (pinchD > 0 && nd > 0) self._zoomAt(null, null, pinchD / nd, pinchHit);
        pinchD = nd;
      } else {                                   // Ein Finger / Maus: frei drehen
        self.tTheta -= (e.clientX - p.x) * 0.006;
        self.tPhi -= (e.clientY - p.y) * 0.006;
        self.tPhi = clamp(self.tPhi, PHI_MIN, PHI_MAX);
        p.x = e.clientX; p.y = e.clientY;
        lastTap = 0;
      }
    }
    function up(e) { pts.delete(e.pointerId); if (pts.size < 2) pinchD = 0; self.dragging = pts.size >= 1; self.idle = 0; }
    el.addEventListener('pointerdown', down);
    window.addEventListener('pointermove', move, { passive: true });
    window.addEventListener('pointerup', up);
    window.addEventListener('pointercancel', up);
    el.addEventListener('wheel', function (e) {
      e.preventDefault();
      var d = e.deltaY * (e.deltaMode === 1 ? 33 : (e.deltaMode === 2 ? 400 : 1));
      self._zoomAt(e.clientX, e.clientY, clamp(Math.exp(d * 0.0012), 0.75, 1.33));
      self.idle = 0; self.autoCycle = false;
    }, { passive: false });
    el.addEventListener('dblclick', function (e) { e.preventDefault(); self.resetView(); });
    this._ctl = { move: move, up: up };
  };

  Viewer.prototype._resize = function () {
    var w = this.host.clientWidth || 600, h = this.host.clientHeight || 480;
    this.renderer.setSize(w, h, false);
    this.cam.aspect = w / h; this.cam.updateProjectionMatrix();
    this._measure();
    // Startabstand an Seitenverhältnis und Rahmen anpassen; Zoomstufe bleibt erhalten
    if (this.box && !this.box.isEmpty() && this.homeR) {
      this._buildFit();
      this._syncHome();
    }
  };

  // Kamera nie im Bauteil: liegt sie in der (leicht vergrößerten) Hülle,
  // rückt sie entlang der Blickachse bis knapp vor die Oberfläche.
  Viewer.prototype._clearance = function (o, d, r) {
    var b = this.box, m = this.fitR * 0.03, t0 = -Infinity, t1 = Infinity;
    var mins = [b.min.x - m, b.min.y - m, b.min.z - m], maxs = [b.max.x + m, b.max.y + m, b.max.z + m];
    var os = [o.x, o.y, o.z], ds = [d.x, d.y, d.z];
    for (var i = 0; i < 3; i++) {
      if (Math.abs(ds[i]) < 1e-9) { if (os[i] < mins[i] || os[i] > maxs[i]) return r; continue; }
      var a = (mins[i] - os[i]) / ds[i], c = (maxs[i] - os[i]) / ds[i];
      if (a > c) { var s = a; a = c; c = s; }
      if (a > t0) t0 = a;
      if (c < t1) t1 = c;
    }
    if (t0 > t1) return r;
    return (r > t0 && r < t1) ? t1 : r;
  };

  Viewer.prototype._start = function () {
    if (this.raf) return;
    var self = this;
    var loop = function (t) {
      self.raf = requestAnimationFrame(loop);
      var dt = self.lastT ? Math.min(4, (t - self.lastT) / 16.67) : 1; self.lastT = t;
      if (!self.dragging && self.cfg.autorotate && !REDUCE) {
        self.idle = (self.idle || 0) + dt;
        if (self.idle > 36) self.tTheta += 0.0022 * dt; // resume after idle
      }
      // auto-cycle through the product showcase (~6 s each), until the user picks a tab
      if (self.autoCycle && self.products.length > 1 && !self.dragging && !REDUCE) {
        self.cycleT = (self.cycleT || 0) + dt;
        if (self.cycleT > 360) {
          self.cycleT = 0;
          var ni = (self.products.indexOf(self.product) + 1) % self.products.length;
          self.setProduct(self.products[ni], false);
        }
      }
      self._syncHome();
      // damping
      var k = 1 - Math.pow(0.88, dt);
      self.theta += (self.tTheta - self.theta) * k;
      self.phi += (self.tPhi - self.phi) * k;
      self.radius += (self.tRadius - self.radius) * k;
      self.target.lerp(self.tTarget, k);
      var r = self._placeCamera();
      // Bodenschatten nur von oben (blendet zur Seitenansicht hin aus)
      var el = (self.cam.position.y - self.groundY) / Math.max(1e-6, r);
      var f = clamp(el / 0.22, 0, 1);
      self.shadowMat.opacity = 0.2 * f;
      self.blobMat.opacity = 0.5 * f;
      self.ground.visible = self.blob.visible = f > 0.001;
      self.renderer.render(self.scene, self.cam);
    };
    this.raf = requestAnimationFrame(loop);
  };

  Viewer.prototype._stop = function () {
    if (this.raf) { cancelAnimationFrame(this.raf); this.raf = 0; this.lastT = 0; }
  };

  Viewer.prototype.dispose = function () {
    this._stop();
    if (this._io) this._io.disconnect();
    if (this._ro) this._ro.disconnect();
    window.removeEventListener('pointermove', this._ctl.move);
    window.removeEventListener('pointerup', this._ctl.up);
    window.removeEventListener('pointercancel', this._ctl.up);
    this._clear();
    [this.threadTex, this.blobTex, this.blobMat, this.shadowMat, this.ground && this.ground.geometry, this.blob && this.blob.geometry]
      .forEach(function (d) { if (d && d.dispose) d.dispose(); });
    if (this.envRT) this.envRT.dispose();
    if (this.renderer) this.renderer.dispose();
  };

  /* ---------- Wiring ---------- */
  function initHost(host) {
    if (host.dataset.gw3dInit) return;
    host.dataset.gw3dInit = '1';
    if (!webglOK()) { host.classList.add('gw-3d-fail'); return; }
    var io = new IntersectionObserver(function (ents, obs) {
      if (!ents[0].isIntersecting) return;
      obs.disconnect();
      loadThree().then(function (THREE) {
        try {
          host.__gw3d = new Viewer(host, THREE);
          try { host.dispatchEvent(new CustomEvent('gw3d:ready', { bubbles: true, detail: { viewer: host.__gw3d } })); } catch (e2) { /* ältere Browser */ }
        }
        catch (err) { host.classList.add('gw-3d-fail'); if (window.console) console.warn('GW3D init failed', err); }
      }).catch(function () { host.classList.add('gw-3d-fail'); });
    }, { rootMargin: '200px' });
    io.observe(host);
  }

  function scan(scope) {
    (scope || document).querySelectorAll('.gw-3d').forEach(initHost);
  }

  // Preset buttons: <button class="gw-3d-preset" data-l data-w data-target="#id">
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.gw-3d-preset');
    if (!btn) return;
    var group = btn.closest('[data-gw3d-group]') || document;
    var host = group.querySelector('.gw-3d');
    if (!host || !host.__gw3d) return;
    host.__gw3d.setBoard({ L: num(btn.getAttribute('data-l'), 300), W: num(btn.getAttribute('data-w'), 300) });
    group.querySelectorAll('.gw-3d-preset').forEach(function (b) { b.classList.remove('gw-active'); });
    btn.classList.add('gw-active');
    var out = group.querySelector('[data-gw3d-spec]');
    if (out) {
      var nx = Math.round(num(btn.getAttribute('data-l'), 300) / 25);
      var nz = Math.round(num(btn.getAttribute('data-w'), 300) / 25);
      out.textContent = nx + ' × ' + nz + ' = ' + (nx * nz) + ' Gewinde M6';
    }
  });

  // Showcase tabs: <button class="gw-3d-tab" data-product="breadboard|table|cnc">
  document.addEventListener('click', function (e) {
    var tab = e.target.closest && e.target.closest('.gw-3d-tab');
    if (!tab) return;
    var wrap = tab.closest('.gw-hero-visual') || tab.parentElement.parentElement;
    var host = wrap && wrap.querySelector('.gw-3d');
    if (!host || !host.__gw3d) return;
    host.__gw3d.setProduct(tab.getAttribute('data-product'), true);
  });

  window.GW3D = {
    scan: scan,
    get: function (host) { return (host && host.__gw3d) || null; },
    version: 2
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(); });
  } else { scan(); }
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll('.gw-3d').forEach(function (h) { if (h.__gw3d) h.__gw3d.dispose(); });
  });
})();
